import type { CanalAbas, MensagemAbas } from '../application/sessao';

const NOME = 'nexital-sessao';

/** BroadcastChannel entre as abas e Web Locks para uma renovação por vez. Sem suporte, vale só esta aba. */
export class CanalAbasNavegador implements CanalAbas {
  private readonly canal = typeof BroadcastChannel === 'undefined' ? null : new BroadcastChannel(NOME);

  publicar(mensagem: MensagemAbas) {
    this.canal?.postMessage(mensagem);
  }

  ouvir(aoReceber: (mensagem: MensagemAbas) => void) {
    this.canal?.addEventListener('message', (evento: MessageEvent<MensagemAbas>) => aoReceber(evento.data));
  }

  exclusivo<T>(trabalho: () => Promise<T>): Promise<T> {
    return 'locks' in navigator ? navigator.locks.request(NOME, () => trabalho()) : trabalho();
  }
}
